import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#38FAA3",
      d: "M12.964 24.668c1.84-8.303 10.064-13.542 18.368-11.702a2.1 2.1 0 1 0 .909-4.1C21.673 6.523 11.206 13.191 8.863 23.759s4.325 21.035 14.894 23.378 21.034-4.325 23.377-14.893a2.1 2.1 0 1 0-4.1-.91c-1.841 8.304-10.065 13.543-18.368 11.702-8.304-1.84-13.543-10.064-11.702-18.368"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#38FAA3",
      d: "M44.884 18.985a2.1 2.1 0 0 0-2.97-2.97L27.999 29.93l-6.215-6.215a2.1 2.1 0 0 0-2.97 2.97l7.7 7.7a2.1 2.1 0 0 0 2.97 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }